import React, { Component } from 'react';
import { base } from '../../../config/constants.js'
import { Label, Image, Container, Form, Input, Progress, Loader, Dimmer } from 'semantic-ui-react'
import Select from 'react-select';




export function ShowJerseyImage(props) {
    console.log("wxc41 props.teamSelection:" + props.teamSelection);
    console.log("wxc42 props.shirtColor:" + props.shirtColor);
    console.log("wxc43 props.selectedTeamColor:" + JSON.stringify(props.selectedTeamColor));

    const showJersey = props.teamSelection && (props.itemSelected === 'football' || props.wordCup) && props.shirtColor
        // const showJersey = props.teamSelection && props.itemSelected === 'football' 
        ? <Container>
            <br />
            {/* Disabled Image On Jersey Selection / jersey image */}
            {/* <Image src={props.selectedTeamColor.imageUrl} size='small' centered /> */}
        </Container>
        : ""

    return (
        <div>
            {showJersey}
        </div>
    )
}




export class FootballFormParts extends Component {
    constructor(props) {
        super(props)

        this.state = {
            teams: [],
            percent: 0,
            loading: true
        }
    }


    componentDidMount() {

        if (this.props.ivanDescription && this.props.ivanDescription.includes('worldCup')) {
            console.log("wxc1 ++++++++ this.props.worldCup is TRUE");
            this.getWorldCupTeams();
        } else {
            console.log("wxc12 ++++++++ this.props.worldCup is false");
            this.getFootballTeams();
        }

        // base.fetch('football/teams', {
        //     context: this,
        //     asArray: true,
        //     then(data) {
        //         // console.log(data);
        //         this.setState({
        //             teams: data,
        //             percent: 100,
        //             loading: false
        //         })
        //     }
        // });
    }

    getFootballTeams = () => {
        base.fetch('football/teams', {
            context: this,
            asArray: true,
            then(data) {
                // console.log(data);
                this.setState({
                    teams: data,
                    percent: 100,
                    loading: false
                })
            }
        });
    }

    getWorldCupTeams = () => {
        console.log("wxc14 ++++++++ getWorldCupTeams");

        base.fetch('worldCup/teams', {
            context: this,
            asArray: true,
            then(data) {
                // console.log(data);
                this.setState({
                    teams: data,
                    percent: 100,
                    loading: false
                })
            }
        });

    }


    render() {

        const footBallDropDown = this.state.percent === 0
            ? <Progress color='blue' percent={this.state.percent} autoSuccess >Loading Teams</Progress>
            : <div>
                <Label pointing='below' color='blue'>{'What Team would you like?'}</Label>
                <Select
                    name="form-field-name"
                    value={this.props.teamSelection}
                    options={this.state.teams}
                    onChange={this.props.handleFootballDropDownChange}
                    searchable={false}
                    clearable={false}
                    required={true}
                />
            </div>

        //const showTeamDropDownOnlyForAdmins = this.props.admin
        const showTeamDropDownOnlyForAdmins = this.props.admin
            ? <div>{footBallDropDown}</div>
            :""


        return (
            <div>
                {/* SHIRT COLOR */}
                {/* <Dimmer active={this.state.loading} size='tiny'>
                    <Loader>Loading Teams</Loader>
                </Dimmer> */}

                {footBallDropDown}
                {/* {showTeamDropDownOnlyForAdmins} */}

                <div>
                    <Label pointing='below' color='blue'>Enter your Your Team</Label>
                    <Form.Field
                        name={this.props.typedInTeamNameFieldName}
                        value={this.props.typedInTeamName}
                        control={Input}
                        length='2'
                        placeholder={'Enter your Team name if its not listed'}
                        onChange={this.props.handleTextInputChange} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/football/FootballFormParts.js